import { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { database } from "../../config/firebase";
import { onValue, ref } from "firebase/database";
import { formatDate } from "../../utils/helper";
import BracketComponent from "../../components/Bracket";
import ScheduleComponent from "../../components/Schedule";
import FutsalBanner from '../../assets/images/drawing-futsal.jpg'

const FutsalPage = () => {
  const [matches, setMatches] = useState([]);
  const [loader, setLoader] = useState(true)
  const [tab, setTab] = useState(0)

  useEffect(() => {
    setLoader(true)
    const dataRef = ref(database, "tournaments/futsal");
    const unsubscribe = onValue(dataRef, (snapshot) => {
      const snapshotData = snapshot.val();
      setMatches(snapshotData)
    });
    setLoader(false)
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <Layout file={FutsalBanner} name="Futsal">
      <div className='flex mb-4 cursor-pointer justify-center py-10 text-center'>
        <div onClick={() => setTab(0)}
          className={`rounded-l-lg p-3 border-2 w-24 ${!tab ? "text-white bg-[#2BBACA]" : "bg-white text-[#2BBACA]"}`}>
          Schedule
        </div>
        <div onClick={() => setTab(1)}
          className={`rounded-r-lg p-3 border-2 w-24 ${tab ? "text-white bg-[#2BBACA]" : "bg-white text-[#2BBACA]"}`}>
          Bracket
        </div>
      </div>

      {!loader ? !tab ?
        <div className="md:w-1/2 m-auto">
          <ScheduleComponent datas={matches} />
        </div> : 
        <BracketComponent datas={matches} /> : ''}
    </Layout>
  )
}

export default FutsalPage;
